import { TypObjektEnum } from "../api";

export const keysOfTypObjekt = Object.keys(TypObjektEnum);

export const getTypObjektCaption = (typ: string | TypObjektEnum): string => {
  switch (typ) {
    case TypObjektEnum.PARCELA:
      return "Parcela";
    case TypObjektEnum.BUDOVA:
      return "Budova";
    case TypObjektEnum.BYT:
      return "Byt";
    case TypObjektEnum.NEBYT:
      return "Nebytový prostor";
    case TypObjektEnum.PLOCHA:
      return "Plocha";
    case TypObjektEnum.SIT:
      return "Síť";
    case TypObjektEnum.PREDMET:
      return "Předmět";
    case TypObjektEnum.STAVBA:
      return "Stavba";
    case TypObjektEnum.SLOUP:
      return "Sloup";
    case TypObjektEnum.HROB:
      return "Hrobové místo";
    case TypObjektEnum.PRVEK:
      return "Prvek";
    case TypObjektEnum.PS:
      return "Právo stavby";
    case TypObjektEnum.PRAVO:
      return "Věcné břemeno";
    default:
      return `-`;
  }
};

export const getTypObjektItems = (): { id: TypObjektEnum; name: string }[] => {
  return keysOfTypObjekt.map((t: TypObjektEnum) => ({
    id: t,
    name: getTypObjektCaption(t),
  }));
};
